<template>
  <div class="bottomContainer">
    <div class="left">
      <div class="leftBox">
        <div class="selectedBox">
          <span class="titleSelected">长水AI模型一</span>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="rightBox">
        <div class="chatContainer">
          <div class="chatContainerBox" v-scrollBottom>
            <div class="chatSingle">
              <div>
                <img class="openaiImgChatOne" src="@/assets/csai.png" alt="" />
                <span class="openaiTextChatBox"
                  >您好，我是长水AI，很高兴为您服务，请问您需要什么帮助？</span
                >
              </div>
            </div>
            <div v-for="(item, index) in userArr">
              <div class="time" v-show="dateArr[index]">
                {{ timeArr[index] }}
              </div>
              <div class="chatSingle bigSpace">
                <div>
                  <img class="openaiImgChat" src="@/assets/user.png" alt="" />
                  <span class="openaiTextChat">{{ item }}</span>
                </div>
              </div>
              <div class="chatSingle">
                <div>
                  <img class="openaiImgChatOne" src="@/assets/csai.png" alt="" />
                  <span class="openaiTextChatBox">{{ aiArr[index] }}</span>
                  <div
                    class="resetChat"
                    @click="resetSay(index)"
                    v-show="stopChat[index]"
                  >
                    重新生成
                  </div>
                  <div
                    class="resetChat"
                    @click="stopCurrentSay(index)"
                    v-show="!stopChat[index]"
                  >
                    停止生成
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="inputPosition">
          <textarea
            class="inputContainer"
            v-model="textarea"
            rows="2"
            type="textarea"
            placeholder="请输入~"
            @keydown.enter="keyDown($event)"
            @input="handleInput"
          ></textarea>
          <div class="send" @click="sendEvent">
            <img class="openaiImgSend" src="@/assets/send.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, toRefs, ref, watchEffect, onMounted } from "vue";
import axios from "axios";
import { collapseContextKey } from "element-plus";

// ----------------------------------------------------------------------------------定义变量-----------------------------------------------------------------------------

const state = reactive({
  textarea: "",
  chatText: [],
  replyArr: [],
  timeArr: [],
  dateArr: [],
  value: "",
  chatStream: {},
  userArr: [],
  aiArr: [],
  timeFlag: 0,
  prompts: [],
  stopChat: [],
  currentSayStop: [],
});
const {
  textarea,
  chatText,
  replyArr,
  value,
  chatStream,
  userArr,
  aiArr,
  timeArr,
  dateArr,
  timeFlag,
  prompts,
  stopChat,
  currentSayStop,
} = toRefs(state);

// ----------------------------------------------------------------------------------函数--------------------------------------------------------------------------------

/**
 * 重新生成此条AI回答
 */
const resetSay = (index) => {
  state.aiArr[index] = "请稍等,长水AI正在重新生成,马上做答...";
  let resetPrompts = state.prompts.slice(0, index * 2 + 2);
  resetPrompts.push({
    role: "user",
    content: "重新生成",
  });
  let datas = {
    model: "ZhiPuAi",
    prompt: resetPrompts,
  };
  sendReq(datas, index);
};

/**
 * 停止生成此条AI回答
 */
const stopCurrentSay = (index) => {
  state.currentSayStop[index] = false;
  state.stopChat[index] = true;
  window.controller.abort();
};

/**
 * 向后端发送请求
 * datas_发送请求携带参数
 */
const sendReq = (datas, index) => {
  state.stopChat[index] = false;
  axios
    .post("/home/chat/talkwitheachother", datas)
    .then((response) => {
      let addressStr = response.data.datas_info.address;
      let header = {
        "Content-Type": response.data.datas_info.header[0].slice(13),
        Authorization: response.data.datas_info.header[1].slice(14),
        accept: response.data.datas_info.header[2].slice(7),
      };
      let dataAll = response.data.datas_info.params;
      let chatStr = "";

      // 用来终止fetch请求
      window.controller = new AbortController();
      let signal = window.controller.signal;

      fetch(addressStr, {
        method: "POST",
        signal,
        headers: header,
        mode: "cors", // cors、no-cors 或者 same-origin  解决跨域问题
        credentials: "include", // omit、include、same-origin(默认)。为了在当前域名内自动发送 cookie，必须提供这个选项
        body: JSON.stringify(dataAll),
      })
        .then((responseA) => {
          const reader = responseA.body.getReader();
          const decoder = new TextDecoder("utf-8");
          let buffer = "";

          function processStreamResult(result2) {
            const chunk = decoder.decode(result2.value, { stream: !result2.done });
            buffer += chunk;
            //逐条解析后端返回数据
            // const lines = buffer;
            const lines = buffer.split("\n");
            buffer = lines.pop();
            // 是否停止生成
            if (state.currentSayStop[index]) {
              lines.forEach((line) => {
                if (line.trim().length > 0) {
                  if (line.match(/^data*/gi)) {
                     console.log(line,"yyy")
                    chatStr += line.slice(5);
                    state.aiArr[index] = chatStr;
                    state.prompts[index * 2 + 1] = {
                      role: "assistant",
                      content: chatStr,
                    };
                    if (line.match(/^data:*$/gi)) {
                       console.log("空格")
                      chatStr += '\n'
                    }
                  }
                  if (line.match(/^meta*/gi)) {
                    state.stopChat[index] = true;
                  }
                }
              });
            } else {
              state.currentSayStop[index] = true;
            }
            if (!result2.done) {
              return reader.read().then(processStreamResult);
            }
          }
          return reader.read().then(processStreamResult);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    })
    .catch((error) => {});
};

/**
 * 回车时触发
 */
const keyDown = (e) => {
  if (e.preventDefault) e.preventDefault();
  if (e.key == "Enter" && state.textarea != "") {
    state.userArr.push(state.textarea);
    state.prompts.push({
      role: "user",
      content: state.textarea,
    });
    e.preventDefault(); // 去掉默认的换行
    sendRequest();
  }
};

/**
 * 点击发送按钮发送
 */
const sendEvent = () => {
  if (state.textarea != "") {
    state.userArr.push(state.textarea);
    state.prompts.push({
      role: "user",
      content: state.textarea,
    });
    sendRequest();
  }
};

/**
 * 发送请求时时间及其他处理
 */
const sendRequest = () => {
  var currentDate = new Date();
  var timeStamp = currentDate.getTime();
  var year = currentDate.getFullYear(); // 获取年份
  var month = currentDate.getMonth() + 1; // 获取月份（注意月份从0开始，所以要加1）
  var day = currentDate.getDate(); // 获取日期
  var hours = currentDate.getHours(); // 获取小时
  var minutes = currentDate.getMinutes(); // 获取分钟
  if (state.userArr.length != 0) {
    // 创建一个新的Date对象，表示5分钟后的时间
    let fiveMinutesAgo = new Date(state.timeFlag + 5 * 60 * 1000);
    // 比较两个时间
    if (currentDate > fiveMinutesAgo) {
      state.dateArr.push(month + "月" + day + "日");
      if (minutes / 10 < 1) {
        state.timeArr.push(hours + ":" + "0" + minutes);
      } else {
        state.timeArr.push(hours + ":" + minutes);
      }
    } else {
      state.dateArr.push(false);
      state.timeArr.push(false);
    }
  } else {
    state.dateArr.push(month + "月" + day + "日");
    if (minutes / 10 < 1) {
      state.timeArr.push(hours + ":" + "0" + minutes);
    } else {
      state.timeArr.push(hours + ":" + minutes);
    }
  }
  let userArrLength = state.userArr.length;
  const req = async () => {
    state.aiArr.push("请稍等,长水AI正在思考,马上做答...");
    let datas = {
      model: "ZhiPuAi",
      prompt: state.prompts,
    };
    sendReq(datas, userArrLength - 1);
  };
  state.timeFlag = timeStamp;
  req();
  send.style.background = "#4871c0";
  state.textarea = "";
};
let send = "";

/**
 * 挂载后
 */
onMounted(() => {
  send = document.querySelector(".send");
});

/**
 * 输入文字触发
 */
const handleInput = () => {
  if (state.textarea != "") {
    send.style.background = "#2F5FBD";
  } else {
    send.style.background = "#4871c0";
  }
};
</script>

<style lang="less" scoped>
.bigSpace {
  margin-top: 30px;
}

::-webkit-scrollbar {
  display: none;
}

.titleContainer {
  position: relative;
  width: 100%;
  height: 3%;
  background: #121212;
  z-index: 1;

  .titleImg {
    position: relative;
    left: 22px;
    top: 10px;
    width: 106px;
    height: 36px;
  }
}

.bottomContainer {
  position: absolute;
  top: 0;
  width: 100%;
  min-width: 1000px;
  height: 100%;
  min-height: 600px;
  background: #252525;

  .left {
    float: left;
    width: 20%;
    // min-width: 200px;
    // max-width: 284px;
    height: 100%;
    background: #f5f9ff;
    .leftBox {
      position: absolute;
      // top: 50px;
      top: 3%;
      left: 12px;
      // left: 2%;
      // width: 256px;
      // min-width: 180px;
      // max-width: 256px;
      width: 18%;
      height: 97%;
      //   background-color: #5cd9d9;
      .newChat {
        margin-top: 20px;
        margin-bottom: 20px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 12px;
        border: 1px solid #4871c0;
        color: #4871c0;
        font-size: 16px;
        cursor: pointer;
        .text {
          position: relative;
          top: 1px;
          font-size: 22px;
          margin-right: 5px;
        }
        &:hover {
          border: 1px solid #2f5fbd;
          color: #2f5fbd;
        }
      }
      .historyBox {
        width: 100%;
        height: 70%;
        background-color: #8b5a5a;
        overflow: hidden;
        .history {
          width: 100%;
          height: 100%;
          background-color: #8ef15c;
          overflow: auto;
          .singleHistory {
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            cursor: pointer;
            &:hover {
              border-radius: 8px;
              background: #fff;
            }
            .chatHistoryPng {
              position: relative;
              top: 4px;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
      .selectedBox {
        // position: absolute;
        // // top: 50px;
        // top: 3%;
        // left: 12px;
        // // left: 2%;
        // // width: 256px;
        width: 100%;
        // min-width: 180px;
        // max-width: 256px;
        height: 60px;
        border-radius: 12px;

        background: #fff;
        // background: #805fc2;
        .openaiImg {
          position: absolute;
          left: 22px;
          top: 18px;
          width: 24px;
          height: 24px;
          border-radius: 8px;
        }

        .titleSelected {
          position: absolute;
          left: 40px;
          top: 20px;
          color: #333;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }

  .right {
    float: left;
    position: relative;
    // top: 0;
    // left: 284px;
    // left: 20%;
    // min-left: 200px;
    // max-left: 284px;
    width: 80%;
    //  min-width: 200px;
    // max-width: 284px;
    // width: 1636px;
    height: 100%;
    // background-color: red;
    background-color: #f4f4f4;
    // background-color: #c5e25c;

    .rightBox {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      // right: -788px;
      // float: left;
      width: 788px;
      height: 100%;
      // background-color: #eb449a;
      .chatContainer {
        position: relative;
        // bottom: 5%;
        top: 3%;
        height: 80%;
        // left: 405px;
        // transform: translate(-50%, 0);
        width: 788px;
        // height: 700px;
        // background-color: #1b6722;
        // background-color: #ded5d5;
        overflow: hidden;

        .chatContainerBox {
          width: 100%;
          height: 100%;
          overflow: scroll;
          // background-color: #1b6722;
          .time {
            padding-top: 20px;
            font-size: 12px;
            font-weight: 400;
            color: #999;
            text-align: center;
          }

          .chatSingle {
            position: relative;
            // background-color: #4f4fe9;
            margin-bottom: 24px;

            .openaiImgChat {
              position: absolute;
              top: 0;
              left: 0;
              width: 24px;
              height: 24px;
              border-radius: 4px;
              //   background-color: #7ee629;
            }

            .openaiImgChatOne {
              position: absolute;
              top: 4px;
              left: 0;
              width: 24px;
              height: 24px;
              border-radius: 4px;
            }

            .openaiTextChat {
              width: 730px;
              display: inline-block;
              //   background-color: #e6c2f5;
              margin-left: 34px;
              line-height: 26px;
              color: #333;
              font-size: 15px;
              font-weight: 400;
              text-align: justify;
              word-break: break-all;
              white-space: pre-line;
            }

            .openaiTextChatBox {
              width: 719px;
              display: inline-block;
              // background-color: #e6c2f5;
              margin-left: 34px;
              border-radius: 11px;
              background: #fff;
              color: #333;
              font-size: 15px;
              font-weight: 400;
              padding: 16px;
              padding-right: 20px;
              text-align: justify;
              word-break: break-all;
              line-height: 26px;
              white-space: pre-line;
            }
            .resetChat {
              margin-top: 10px;
              margin-left: 40px;
              font-size: 12px;
              color: #2f5fbd;
              cursor: pointer;
              &:hover {
                color: #033cad;
              }
              img {
                position: relative;
                top: 3px;
                width: 15px;
                height: 15px;
                margin-right: 5px;
              }
            }
          }
        }
      }

      .inputPosition {
        position: absolute;
        bottom: 2%;
        left: 34px;
        // left: 24px;
        // left: 50%;
        // transform: translate(-50%, 0);
        width: 754px;
        height: 88px;
        // height: 20%;
        background-color: #fff;
        border-radius: 11px;
        border: 1px solid #2f5fbd;
        background: #fff;

        .send {
          position: absolute;
          right: 9px;
          bottom: 8px;
          width: 60px;
          height: 36px;
          border-radius: 18px;
          background: #4871c0;
          cursor: pointer;

          .openaiImgSend {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 22px;
            height: 22px;
          }
        }

        // .hideScroll {
        //     position: absolute;
        //     // bottom: 36px;
        //     top: 10%;
        //     left: 12px;
        //     width: 690px;
        //     height: 70px;
        //     overflow: hidden;
        //     background-color: #38cebd;

        .inputContainer {
          position: absolute;
          // bottom: 36px;
          top: 10%;
          left: 12px;
          // // bottom: 36px;
          // top: 10%;
          // left: 12px;
          // transform: translate(-50%, 0);
          width: 670px;
          height: 70px;
          background: #fff;
          // background: #d23030;
          border: none;
          color: #333;
          resize: none;
          outline: none;
          // background-color: #d75353;
        }

        // }
      }
    }
  }
}
</style>
